import { ButtonPrimary, ButtonPseudo } from '@ui/src';
import { ConfirmPopupTypes } from './types';

import cn from './styles.module.css';

const ConfirmPopup = ({
  onSubmit,
  onCancel,
  isLoading,
  userName,
  globalError,
  editIsLoading,
}: ConfirmPopupTypes): React.JSX.Element => (
  <div className={cn.confirmPopup}>
    <div className={cn.confirmPopupButtons}>
      {globalError && <div className={cn.globalError}>{globalError}</div>}
      <ButtonPrimary
        bold
        text={editIsLoading ? 'Loading...' : `Save settings to ${userName}`}
        disabled={isLoading || editIsLoading}
        onClick={onSubmit}
      />
      <ButtonPseudo
        bold
        text="Cancel"
        className="button-white"
        onClick={onCancel}
      />
    </div>
  </div>
);

export default ConfirmPopup;
